import 'core-js/stable'
import 'regenerator-runtime/runtime'

import BootstrapVue from 'bootstrap-vue'
import * as uiv from 'uiv'
import Viewer from 'v-viewer'
import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import App from './App.vue'
import router from './router'
import store from './store'
import MainLayout from './layouts/MainLayout.vue'
import VueMeta from 'vue-meta'
import mainMixin from './common/mixins/mainMixin'
import VueDropzone from './common/components/inputs/VueDropzone.vue'
import VueScrollTo from 'vue-scrollto'
import DatePicker from 'vue2-datepicker'
import MessageAlert from './common/components/application/MessageAlert'
import InputFacade from 'vue-input-facade'
import vueHeadful from 'vue-headful'
import VTooltip from 'v-tooltip'
import AsyncComputed from 'vue-async-computed'

import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap-theme.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'viewerjs/dist/viewer.css'

import './assets/styles/pdf.css'
import './common/assets/styles/style.scss'
import './modules/sign_widget/assets/styles/style.scss'
import './assets/styles/styles.scss'
import './assets/styles/media.scss'
import './common/assets/styles/media.scss'
import './assets/styles/bootstrap-conflicts.scss'
import './assets/styles/pt-sans.css'
import './assets/styles/font-awesome.min.css'
import './assets/styles/vue2Dropzone.css'
import './assets/styles/date-picker.css'
import 'vue-select/dist/vue-select.css';
import './common/assets/styles/override-vue-select.scss'
import '@/common/assets/styles/vue-tooltip2.scss'

Vue.component('main-layout', MainLayout)
Vue.component('vue-dropzone', VueDropzone)
Vue.component('date-picker', DatePicker)
Vue.component('message-alert', MessageAlert)
Vue.component('vue-headful', vueHeadful)

Vue.use(InputFacade)
Vue.use(VueScrollTo)
Vue.use(uiv)
Vue.use(BootstrapVue)
Vue.use(Viewer)
Vue.use(InfiniteLoading)
Vue.use(VueMeta)
Vue.use(VTooltip)
Vue.use(AsyncComputed)

Vue.config.productionTip = false
Vue.mixin(mainMixin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
